import script from "./Penjualan.vue?vue&type=script&setup=true&lang=js"
export * from "./Penjualan.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__